import { DataObject } from '@shared/models/data-object.model';
import { groupCompaniesContacts } from '@records/records-search/records-details/record-detail-container/custom-entity-details/entities/property/helpers';
export function extractCompanies(companyContactEntries): Array<DataObject> {
  return groupCompaniesContacts(companyContactEntries || []);
}
export interface PreprocessorCompanyContacts {
  processCompanyContacts(record: DataObject): DataObject;
}
